module.exports = __webpack_public_path__ + "static/media/writersBg.7befdc0c.png";